import { BetQLSportItem } from "./";
import { DEFAULT_TREND_TYPES } from "./configs";

const EUROS2024Config: BetQLSportItem = {
  id: "054eb4de-6395-4bcd-9176-afe3eaf0c3f4",
  name: "Euros 2024",
  url: "euros2024",
  tabName: "Euros 2024",
  icon: "soccer",
  imagePath: "UCL",
  key: "UCL",
  lookupKey: "euros2024",
  favoriteLine: "moneyline",
  isSoccer: true,
  hasTeamPowerProjectionGrades: true,
  hasFGspreadPowerRating: true,
  hasFGmoneylinePowerRating: true,
  hasFGtotalPowerRating: true,
  has1HspreadPowerRating: false,
  has1HmoneylinePowerRating: false,
  has1HtotalPowerRating: false,
  has1PspreadPowerRating: false,
  has1PmoneylinePowerRating: false,
  has1PtotalPowerRating: false,
  hasPitchers: false,
  hasGoals: true,
  hasInjuries: false,
  hasNews: false,
  hasLineup: false,
  hasSchedule: true,
  hasConfiguredSchedule: true,
  hasTeamSummary: true,
  hasGameFilters: true,
  hasStadium: true,
  hasLocation: true,
  hasTeamRecord: true,
  hasApRank: false,
  hasConferenceDropdown: false,
  hasNewsInjuriesColumn: false,
  hasDraws: true,
  hasSharpData: true,
  hasTopTrendsData: false,
  hasPlayerProps: false,
  hasRecommendedBets: false,
  hasPopularEvents: false,
  isCollege: false,
  defaultUserSetting: '{"name": "Default Setting", "columnOrder": [2,4,9,5,14]}',
  defaultColumnOrder: [2, 4, 9, 5, 14],
  publicThreshold: 60,
  sharpPercentThreshold: 20,
  sharpCountThreshold: 500,
  publicCountThreshold: 500,
  trendTypes: DEFAULT_TREND_TYPES,
  filters: [
    {
      name: "Moneyline",
      key: "moneyline",
      url: "moneyline",
    },
    {
      name: "Total",
      key: "total",
      url: "over-unders",
    },
    {
      name: "Spread",
      key: "spread",
      url: "spread",
    },
    {
      name: "1st Half Moneyline",
      key: "1Hmoneyline",
      url: "first-half-moneyline",
    },
    {
      name: "1st Half Spread",
      key: "1Hspread",
      url: "first-half-lines",
    },
    {
      name: "2nd Half Moneyline",
      key: "2Hmoneyline",
      url: "second-half-moneyline",
    },
    {
      name: "2nd Half Spread",
      key: "2Hspread",
      url: "second-half-line",
    },
  ],
  periods: ["FULLGAME", "FIRSTHALF", "SECONDHALF"],
  periodKeys: ["FG", "1H", "2H"],
  pickTypes: ["moneyline", "total", "spread", "1Hmoneyline", "1Hspread", "2Hmoneyline", "2Hspread"],
};

export default EUROS2024Config;
